import gql from "graphql-tag";
import PropTypes from "prop-types";

export default {
  mutation: gql`
    mutation blockCard(
      $cardId: ID!
      $blockReasonId: ID!
      $blockComment: String
    ) {
      blockCard(
        cardId: $cardId
        blockReasonId: $blockReasonId
        blockComment: $blockComment
      ) {
        success
      }
    }
  `,
  config: {
    skip: (ownProps) => !ownProps.cardId,
    options: ({ cardId, blockReasonId, blockComment }) => ({
      variables: {
        cardId,
        blockReasonId,
        blockComment,
      },
    }),
  },
  propTypes: {
    cardId: PropTypes.string.isRequired,
    blockReasonId: PropTypes.string.isRequired,
    blockComment: PropTypes.string,
  },
};



// WEBPACK FOOTER //
// ./src/model/gql/mutations/cards/blockCard.js